import { render, staticRenderFns } from "./cliente_cotizar.vue?vue&type=template&id=0d886766"
import script from "./cliente_cotizar.vue?vue&type=script&lang=js"
export * from "./cliente_cotizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports